@if (canInvite) {
  <button mat-menu-item (click)="onInvite.emit()" class="invite-btn">{{'common_invite' | translate}}</button>
}
@if (canCreateCourse) {
  <button mat-menu-item (click)="onCreateCourse.emit()" class="create-folder-btn">{{'folders_view-create_button' | translate}}</button>
}
